
import { Options, Vue } from "vue-class-component";
import StockService from "../../service/StockService.js";
import { reactive } from "vue";
import useVuelidate from "@vuelidate/core";
import { required, minLength, maxLength } from "@vuelidate/validators";
import Toaster from "../../helpers/Toaster";
import moment from "moment";
import AutoComplete from "primevue/autocomplete";

import FileUploader from "../../components/FileUploader.vue";

@Options({
  title: "Import Stock",
  components: {
    AutoComplete,
    FileUploader,
  },
})
export default class ImportStock extends Vue {
  private taxName1 = "";
  private taxName2 = "";
  private taxName3 = "";

  private totalInValid = 0;
  private totalValid = 0;

  private productType = [
    {
      id: 0,
      option_name: "",
    },
  ];
  private brand = [
    {
      id: 0,
      option_name: "",
    },
  ];
  private brandSector = [
    {
      id: 0,
      option_name: "",
    },
  ];
  private category = [
    {
      id: 0,
      option_name: "",
    },
  ];

  private toast;
  private stockService;
  private uploaderStatus = false;
  private home = { icon: "pi pi-home", to: "/" };
  private items = [
    { label: "Initialization", to: "initialization" },
    { label: "Import Stock", to: "import-stock" },
  ];

  private excelFileContent = [
    {
      productName: "",
      genericName: "",
      barcode: "",
      productType: 0,
      brandName: 0,
      brandSector: 0,
      category: 0,
      sideEffects: "",
      packSize: 0,
      stripSize: 0,
      pack: 0,
      strip: 0,
      unit: 0,
      // quantity: 0,
      expiryDate: "",
      packPurchasePrice: 0,
      stripPurchasePrice: 0,
      unitPurchasePrice: 0,
      //   packSellingPrice: 0,
      //   mRP: 0,
      packSalePrice: 0,
      stripSalePrice: 0,
      unitSalePrice: 0,
      batchNo: "",
      tax_1: 0,
      tax_2: 0,
      tax_3: 0,
      discountPercentage: 0,
      description: "",
      minimumStock: 0,
      storeLocations: "",
    },
  ];

  //DEFAULT METHOD OF TYPE SCRIPT
  created() {
    this.stockService = new StockService();
    this.toast = new Toaster();
  }

  //CALLNING AFTER CONSTRUCTOR GET CALLED
  mounted() {
    this.loadList();
  }

  //OPEN DIALOG TO ADD NEW ITEM
  downloadSample() {
    this.stockService.exportSampleStock().then((res) => {
      let fileURL = window.URL.createObjectURL(new Blob([res]));
      let fileLink = document.createElement("a");
      fileLink.href = fileURL;
      fileLink.setAttribute("download", "sampleData.csv");
      document.body.appendChild(fileLink);
      fileLink.click();
    });
  }

  //FETCH THE DATA FROM SERVER
  loadList() {
    this.stockService.getItems().then((data) => {
      this.productType = data.productType;
      this.brand = data.brand;
      this.brandSector = data.brandSector;
      this.category = data.category;

      this.taxName1 =
        data.storeTaxes[0].show_1 == "true"
          ? data.storeTaxes[0].tax_name_1
          : "";
      this.taxName2 =
        data.storeTaxes[0].show_2 == "true"
          ? data.storeTaxes[0].tax_name_2
          : "";
      this.taxName3 =
        data.storeTaxes[0].show_3 == "true"
          ? data.storeTaxes[0].tax_name_3
          : "";
    });
  }

  openFileUploader() {
    this.uploaderStatus = true;
  }

  updateUploaderStatus(params) {
    this.uploaderStatus = false;
    if (params.length > 0) {
      this.excelFileContent = [];

      this.stockService.uploadCSVFile(params[0]).then((res) => {
        if (res.length > 0) {
          res.forEach((e) => {
            if (e[0] != "Product Name (*) [Text]") {
              let categoryID = 0;
              let bandID = 0;
              let bandSectorID = 0;
              let productTypeID = 0;

              const normalize = (str: string) => str?.normalize('NFC').replace(/\s+/g, '') ?? '';

              // Product Type
              let productTypeOption = this.productType.find(i => normalize(i.option_name) === normalize(e[3]));
              if (!productTypeOption) {
                productTypeOption = { id: Date.now(), option_name: e[3] };
                this.productType.push(productTypeOption);
              }
              productTypeID = productTypeOption.id;

              // Brand Name
              let brandOption = this.brand.find(i => normalize(i.option_name) === normalize(e[4]));
              if (!brandOption) {
                brandOption = { id: Date.now() + 1, option_name: e[4] };
                this.brand.push(brandOption);
              }
              bandID = brandOption.id;

              // Brand Sector
              let brandSectorOption = this.brandSector.find(i => normalize(i.option_name) === normalize(e[5]));
              if (!brandSectorOption) {
                brandSectorOption = { id: Date.now() + 2, option_name: e[5] };
                this.brandSector.push(brandSectorOption);
              }
              bandSectorID = brandSectorOption.id;

              // Category
              let categoryOption = this.category.find(i => normalize(i.option_name) === normalize(e[6]));
              if (!categoryOption) {
                categoryOption = { id: Date.now() + 3, option_name: e[6] };
                this.category.push(categoryOption);
              }
              categoryID = categoryOption.id;

              this.excelFileContent.push({
                productName: e[0],
                genericName: e[1],
                barcode: e[2],
                productType: productTypeID,
                brandName: bandID,
                brandSector: bandSectorID,
                category: categoryID,
                sideEffects: e[7],
                packSize: Number(e[8]),
                stripSize: Number(e[9]),
                pack: Number(e[10]),
                strip: Number(e[11]),
                unit: Number(e[12]),
                // quantity: Number(e[10]),
                expiryDate: e[13],
                packPurchasePrice: Number(e[14]),
                stripPurchasePrice: Number(e[15]),
                unitPurchasePrice: Number(e[16]),
                // packSellingPrice: 0,
                // mRP: Number(e[13]),
                packSalePrice: Number(e[17]),
                stripSalePrice: Number(e[18]),
                unitSalePrice: Number(e[19]),
                batchNo: e[20],
                tax_1: Number(e[21]),
                tax_2: Number(e[22]),
                tax_3: Number(e[23]),
                discountPercentage: Number(e[24]),
                description: e[25],
                minimumStock: Number(e[26]),
                storeLocations: e[27],
              });
            }
          });
        }
      });
    }
  }

  saveFileData() {
    if (this.validateStock.length == 0) {
      this.stockService.save(this.excelFileContent).then((res) => {
        this.clearAll();
        this.toast.handleResponse(res);
      });
    } else {
      this.toast.showWarning("Some of the fields are invalid");
    }
  }

  clearAll() {
    this.excelFileContent = [];
    this.totalInValid = 0;
    this.totalValid = 0;
    this.addNewRow();
    this.toast.showSuccess("Cleared Successfully");
  }

  addNewRow() {
    this.excelFileContent.push({
      productName: "",
      genericName: "",
      barcode: "",
      productType: 0,
      brandName: 0,
      brandSector: 0,
      category: 0,
      sideEffects: "",
      packSize: 0,
      stripSize: 0,
      pack: 0,
      strip: 0,
      unit: 0,
      // quantity: 0,
      expiryDate: "",
      packPurchasePrice: 0,
      stripPurchasePrice: 0,
      unitPurchasePrice: 0,
      //   packSellingPrice: 0,
      //   mRP: 0,
      packSalePrice: 0,
      stripSalePrice: 0,
      unitSalePrice: 0,
      batchNo: "",
      tax_1: 0,
      tax_2: 0,
      tax_3: 0,
      discountPercentage: 0,
      description: "",
      minimumStock: 0,
      storeLocations: "",
    });
  }

  clearListItem(item) {
    this.excelFileContent.splice(this.excelFileContent.indexOf(item), 1);
    this.toast.showSuccess("Row Deleted Successfully");
  }

  // get stockWorth() {
  //   let totalAmount = 0;
  //   this.excelFileContent.forEach((e) => {
  //     if (e.packSize != 0) {
  //       totalAmount =
  //         totalAmount + Number((e.quantity / e.packSize) * e.packPurchasePrice);
  //     }
  //   });
  //   return totalAmount.toFixed(2);
  // }

  // getPackWorth(data) {
  //   let totalAmount = 0;
  //   this.excelFileContent.forEach((e) => {
  //     if (data.packSize != 0) {
  //       totalAmount = Number(
  //         (data.quantity / data.packSize) * data.packPurchasePrice
  //       );
  //     }
  //   });
  //   return totalAmount.toFixed(2);
  // }

  get totalItems() {
    return this.excelFileContent.length;
  }

  get validateStock() {
    this.totalInValid = 0;
    this.totalValid = 0;
    let invalidListItems: Number[] = [];
    this.excelFileContent.map((v, index) => {

      if (
        v.productName == null ||
        v.batchNo == null ||
        v.batchNo == "" ||
        v.productType == 0 ||
        v.brandName == 0 ||
        v.brandSector == 0 ||
        v.category == 0 ||
        // v.packSize <= 0 ||
        v.packSize == null ||
        v.stripSize == null ||
        v.pack == null ||
        v.strip == null ||
        v.unit == null ||
        // v.quantity <= 0 ||
        v.packPurchasePrice == null ||
        v.stripPurchasePrice == null ||
        v.unitPurchasePrice == null ||
        v.packSalePrice == null ||
        v.stripSalePrice == null ||
        v.unitSalePrice == null
        // v.mRP == null ||
        // v.mRP <= 0
      ) {
        this.totalInValid++;
        invalidListItems.push(index);
      } else {
        this.totalValid++;
      }
    });
    return invalidListItems;
  }
}
